export { default } from './trade-object';
